import { useCallback, useEffect, useRef, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/chat`;
const KEY = "cp_chat_session";

const sessionId = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
  }
  return id;
};

export const useChat = (open) => {
  const [messages, setMessages] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const loaded = useRef(false);

  useEffect(() => {
    if (!open || loaded.current) return;
    loaded.current = true;
    fetch(`${API}/${sessionId()}`)
      .then((r) => (r.ok ? r.json() : { messages: [] }))
      .then((d) => setMessages(Array.isArray(d?.messages) ? d.messages : []))
      .catch(() => {});
  }, [open]);

  const send = useCallback(async (text) => {
    const msg = text.trim();
    if (!msg || busy) return;
    setError("");
    setBusy(true);
    setMessages((m) => [...m, { role: "user", content: msg }, { role: "assistant", content: "" }]);
    const append = (t) => setMessages((m) => {
      const copy = [...m];
      copy[copy.length - 1] = { role: "assistant", content: copy[copy.length - 1].content + t };
      return copy;
    });
    try {
      const res = await fetch(`${API}/stream`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId(), message: msg }),
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(typeof d?.detail === "string" ? d.detail : "Al momento non riesco a rispondere.");
      }
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buf = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const chunks = buf.split("\n\n");
        buf = chunks.pop();
        for (const c of chunks) {
          if (!c.startsWith("data: ")) continue;
          const ev = JSON.parse(c.slice(6));
          if (ev.delta) append(ev.delta);
          if (ev.error) throw new Error(ev.error);
        }
      }
      window.gtag?.("event", "chat_message");
    } catch (e) {
      setError(e.message);
      setMessages((m) => (m[m.length - 1]?.content ? m : m.slice(0, -1)));
    } finally {
      setBusy(false);
    }
  }, [busy]);

  return { messages, busy, error, send };
};
